import * as React from 'react';


export default class NeedsCalculationGraph extends React.Component {
    svgElement;
    tooltipElement;

    componentDidUpdate() {
        this.initialize();
    }

    componentDidMount() {
        this.initialize();
    }

    initialize() {
        this.svgElement.addEventListener('mousemove', this.handleGraphMouseMove);
        this.svgElement.querySelectorAll('[data-point]').forEach(pointNode => {
            pointNode.addEventListener('mouseenter', () => this.handlePointMouseEnter(pointNode));
            pointNode.addEventListener('mouseleave', () => this.handlePointMouseLeave(pointNode));
        });
    }

    handlePointMouseEnter(point) {
        if (this.tooltipElement) {

            this.tooltipElement.innerHTML = `
                <div>${point.dataset.label}</div>
                <div>${point.dataset.x} ${this.props.metaData.bottomAxis.unit}</div>
                <div>${point.dataset.y} ${this.props.metaData.leftAxis.unit}</div>`;

            this.tooltipElement.style.opacity = '1';
        }
    }

    handlePointMouseLeave(point) {
        if (this.tooltipElement) {
            this.tooltipElement.style.opacity = '0';
        }
    }

    handleGraphMouseMove = (event) => {
        if (this.tooltipElement) {
            const tooltipRect = this.tooltipElement.getBoundingClientRect();

            this.tooltipElement.style.left = (event.offsetX - (tooltipRect.width / 2)) + 'px';
            this.tooltipElement.style.top = (event.offsetY - tooltipRect.height - 20) + 'px';
        }
    };

    render() {
        return (
            <div style={{position: 'relative'}}>
                <div ref={e => this.tooltipElement = e} className="needs-calculation-tooltip"></div>
                <div ref={e => this.svgElement = e} dangerouslySetInnerHTML={{__html: this.props.code}}></div>
            </div>
        );
    }
}
